exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1sponYEThoXV3ckw3ViCSc .campaign-creative.campaign-creative--active{background:dycolor-internal(!active,@secondary)}._1sponYEThoXV3ckw3ViCSc .campaign-creative.campaign-creative--active .campaign-creative-head{color:dycolor-internal(!head,@theme-white)}._1sponYEThoXV3ckw3ViCSc .campaign-creative.campaign-creative--active button{background:dycolor-internal(!button,@tertiary)}._1sponYEThoXV3ckw3ViCSc .campaign-creative.campaign-creative--active button:hover{background:dycolor-internal(!button-hover,@tertiary)}._1sponYEThoXV3ckw3ViCSc .campaign-creative-content{background:dycolor-internal(!content,@theme-white)}\n", ""]);

// exports
exports.locals = {
	"root": "_1sponYEThoXV3ckw3ViCSc"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/campaign-creatives/creative/Creative.scss
// module id = 893
// module chunks = 1